<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular') }} {{ $t('adiantamento') }}
                </h1>
            </div>
            <div class="header-buttons">
                <button
                    class="delete-btn"
                    type="button"
                    @click="onFecharModal"
                >
                    {{ $t("cancelar") }}
                </button>

                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="adiantamentoSelected.length === 0"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="adiantamentoSelect"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="adiantamentoSelected"
                :custom-is-checked="(selecionados, linha) => selecionados.idadiantamento === linha.idadiantamento"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    v-slot="props"
                >
                    <div v-if="f.key == 'valor'">
                        {{ props.row.valor | decimal(null, true) }}
                    </div>

                    <div v-else-if="f.key == 'datahorainc'">
                        {{ props.row.datahorainc | moment("L LT") }}
                    </div>
                    <div v-else-if="f.key == 'observacao-geral'">
                        {{ props.row[f.key] | cutString() }}
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// SERVICES
import AssAdiantamentoAcerto from "@/services/despesas/AssAdiantamentoAcertoService.js";
import Message from "@/models/Message";

export default {
    props: {
        acertoDespesa: null,
    },
    data() {
        return {
            service: new AssAdiantamentoAcerto(this.$http, this.$router),
            isLoading: false,
            isEmpty: false,
            fields: [
                {key: 'codigo', width: null, sortable: true},
                {key: 'valor', width: 150, sortable: true},
                {key: 'observacao-geral', width: null, sortable: true},
                {key: 'datahorainc', width: 120, sortable: true},
            ],
            adiantamentoSelect: [],
            adiantamentoSelected: [],
            idadiantamento: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'nome',
            order: 'asc',
            msgs: [],
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[
            this.pagination.optionStarted
        ];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.service
            .findNaoAssociados(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.acertoDespesa,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.adiantamentoSelect = value;
                this.isEmpty = this.adiantamentoSelect.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map(m => {
                return {
                    codigo: m.idadiantamento,
                    idadiantamento: m.idadiantamento,
                    valor: m.valor,
                    'observacao-geral': m.obsgeral,
                    datahorainc: m.datahorainc,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.adiantamentoSelected.length > 0) {
                this.isLoading = true;

                let assAcertoDespesaAdiantamentoList = [];
                this.adiantamentoSelected.forEach(adiantamento => {
                    assAcertoDespesaAdiantamentoList.push( {
                        uuiddes_acerto_despesa: this.acertoDespesa.uuid,
                        idadiantamento: adiantamento.idadiantamento,
                        origem: 'WEB',
                    })
                });
                
                this.service.save(assAcertoDespesaAdiantamentoList)
                .then(value => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                        this.$emit('fecharModal', true);
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            } else {
                this.msgs.push(new Message("error", 'msg-selecione-registro', true));
                this.isLoading = false;
            }
        },

        onFecharModal(){
            this.$emit('fecharModal',true);
        }
    },
}
</script>


<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>